import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import styles from "./RefillUnitInputPanel.module.css";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaFormField } from "@coworker/apprestructured/src/shared/wrappers/FixaFormField/FixaFormField";
import { Trans } from "@coworker/locales";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import NoticeRedSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/NoticeRedSmallIconPath";
import WarningTriangleOrangeSmallPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/WarningTriangleOrangeSmallPath";
import { UnitType } from "../constants";

export type RefillUnitInputPanelProps = {
  infoText?: string;
  type: UnitType;
  value: number;
  onChange: (value: number) => void;
  suffixLabel: string;
  max: number;
  current: number;
  errorMsg?: string;
  warningMsg?: string;
  isError?: boolean;
  isWarning?: boolean;
};

export function RefillUnitInputPanel(props: RefillUnitInputPanelProps) {
  return (
    <>
      {props.infoText && (
        <FixaText textStyle="Body.S" className={styles["infoText"]!}>
          {props.infoText}
        </FixaText>
      )}
      <FixaFormField
        valid={
          props.isError ? "error" : props.isWarning ? "warning" : "success"
        }
        shouldValidate={(props.isError || props.isWarning) ?? false}
        className={styles["formField"]!}
      >
        <FixaInputField
          id={String(props.type)}
          type="number"
          value={String(props.value)}
          onChange={(e) => props.onChange(Number(e.target.value))}
          className={styles["inputField"]!}
          suffixLabel={props.suffixLabel}
        />
      </FixaFormField>
      <div className={styles["capacityAndMessages"]}>
        {props.isError && props.errorMsg ? (
          <FixaText textStyle="Body.S" className={styles["error"]!}>
            <FixaSSRIcon paths={NoticeRedSmallIconPath} />
            {props.errorMsg}
          </FixaText>
        ) : (
          props.isWarning &&
          props.warningMsg && (
            <FixaText textStyle="Body.S" className={styles["warning"]!}>
              <FixaSSRIcon paths={WarningTriangleOrangeSmallPath} />
              {props.warningMsg}
            </FixaText>
          )
        )}
        <FixaText textStyle="Body.S">
          {!props.isError && !props.isWarning && (
            <Trans>maximumCapacityString</Trans>
          )}
        </FixaText>
        <FixaText textStyle="Body.S">
          <span
            className={`${props.isError ? styles["error"] : props.isWarning ? styles["warning"] : ""}`}
          >
            {props.current}
          </span>
          /{props.max}
        </FixaText>
      </div>
    </>
  );
}
